<mat-dialog-content data-testid="cy-runtime-list">
    <h2 mat-dialog-title i18n="@@runtime-download-title">Download Runtime</h2>

    <p i18n="@@runtime-download-description">Choose your Scope Runtime version to download and install.</p>

    <mat-nav-list>
        <ng-container *ngFor="let runtime of runtimes">
            <a mat-list-item href="{{ runtime.url }}" target="_blank" (click)="doDownload($event)">
                <span mat-line>
                    <mat-icon
                        class="riege-icon {{ runtime.icon }}"
                        svgIcon="{{ runtime.icon }}"
                        aria-hidden="true"></mat-icon>
                    {{ runtime.os }}
                </span>
                <span mat-line class="description">{{ runtime.description }}</span>
            </a>
        </ng-container>
    </mat-nav-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="riege-button" mat-flat-button i18n="@@button-label-back" (click)="cancelDownload();">Back</button>

    <button class="riege-button" mat-flat-button mat-dialog-close color="primary" i18n="@@button-label-close"
        >Close</button
    >
</mat-dialog-actions>
